export const API_BASE_URL = "https://genomin.liara.run/";
export const FRONT_URL = "https://lab.genomin.com/";
export default async ({
  route,
  token = false,
  method,
  body,
  contentType = true
}) =>
  new Promise((resolve, reject) => {
    const headers = { authorization: token ? token : null };
    if (contentType) {
      headers["Content-Type"] = "application/json";
      headers["Accept"] = "application/json";
    }
    fetch(`${API_BASE_URL}${route}`, {
      headers,
      method: method,
      body: body ? body : null
    })
      .then(async res => {
        try {
          if (res.status >= 200 && res.status < 300) {
            const noContact = res.status === 202 || res.status === 204;
            resolve(noContact ? res.status : res.json());
          } else {
            reject(await res.json());
          }
        } catch (err) {
          reject(res);
        }
      })
      .catch(reject);
  });
